import { FeedbackItem } from '../models';
import {
  FEEDBACK_ITEM_STATUSES,
  FEEDBACK_ITEM_TYPES
} from '../constants';
import { getFeedbackItem } from './selectors';

export const SET_FEEDBACK_OPEN = 'LS_STUDIO_FEEDBACK/SET_FEEDBACK_OPEN';

export const CREATE_FEEDBACK_ITEM = 'LS_STUDIO_FEEDBACK/CREATE_FEEDBACK_ITEM';
export const DELETE_FEEDBACK_ITEM = 'LS_STUDIO_FEEDBACK/DELETE_FEEDBACK_ITEM';
export const SELECT_FEEDBACK_ITEM = 'LS_STUDIO_FEEDBACK/SELECT_FEEDBACK_ITEM';
export const UPDATE_FEEDBACK_ITEM = 'LS_STUDIO_FEEDBACK/UPDATE_FEEDBACK_ITEM';

export const setFeedbackOpen = (isOpen) => ({
  type: SET_FEEDBACK_OPEN,
  payload: {
    isOpen
  }
});

export const createFeedbackItem = ({ feedbackItem }) => ({
  type: CREATE_FEEDBACK_ITEM,
  payload: {
    feedbackItem
  }
});

export const deleteFeedbackItem = ({ id }) => ({
  type: DELETE_FEEDBACK_ITEM,
  payload: {
    id
  }
});

export const selectFeedbackItem = ({ id }) => ({
  type: SELECT_FEEDBACK_ITEM,
  payload: {
    id
  }
});

export const updateFeedbackItem = ({ id, updateData }) => ({
  type: UPDATE_FEEDBACK_ITEM,
  payload: {
    id,
    updateData
  }
});

export const closeFeedback = () => dispatch => {
  dispatch(selectFeedbackItem({ id: null }));
  dispatch(setFeedbackOpen(false));
};

export const selectFeedbackCategory = ({ feedbackId, categoryKey }) => (dispatch, getState) => {
  const feedbackItem = getFeedbackItem({ id: feedbackId, state: getState() });
  dispatch(updateFeedbackItem({
    updateData: {
      categories: [
        ...feedbackItem.categories(),
        categoryKey
      ]
    },
    id: feedbackId
  }));
};

export const deselectFeedbackCategory = ({ feedbackId, categoryKey }) => (dispatch, getState) => {
  const feedbackItem = getFeedbackItem({ id: feedbackId, state: getState() });
  dispatch(updateFeedbackItem({
    updateData: {
      categories: feedbackItem.categories().filter((c) => c !== categoryKey)
    },
    id: feedbackId
  }));
};

export const updateFeedbackComment = ({ feedbackId, comment }) => (dispatch) => {
  dispatch(updateFeedbackItem({
    updateData: {
      comment
    },
    id: feedbackId
  }));
};

export const editFeedback = ({ feedbackId }) => (dispatch) => {
  dispatch(updateFeedbackItem({
    updateData: {
      status: FEEDBACK_ITEM_STATUSES.EDITING
    },
    id: feedbackId
  }));
};

export const createOrSelectFeedbackItem = ({ createData }) => (dispatch, getState) => {
  const { context: { product, render, design, hotspot }, whRedesignRequestId } = createData;
  const feedbackId = FeedbackItem.buildFeedbackItemKey({
    productId: product && product.id(),
    renderId: render && render.id,
    designId: design && design.id(),
    hotspotUuid: hotspot && hotspot.instance_id,
    whRedesignRequestId
  });
  const existingFeedbackItem = getFeedbackItem({ id: feedbackId, state: getState() });
  if (!existingFeedbackItem) {
    const feedbackItem = new FeedbackItem({ ...createData });
    dispatch(createFeedbackItem({ feedbackItem }));
  }
  dispatch(selectFeedbackItem({ id: feedbackId }));
};

export const requestRenderChanges = ({ render, design, redesignRequest }) => (dispatch, getState) => {
  const createData = {
    context: { render, design },
    type: FEEDBACK_ITEM_TYPES.RENDER,
    imageUrl: render && render.imagefile,
    whRedesignRequestId: redesignRequest && redesignRequest.whRedesignRequestId()
  };
  dispatch(createOrSelectFeedbackItem({ createData }));
  dispatch(setFeedbackOpen(true));
};

export const requestProductChanges = ({ product, render, design, hotspot, redesignRequest }) => (dispatch, getState) => {
  const createData = {
    context: { product, render, design, hotspot },
    type: FEEDBACK_ITEM_TYPES.PRODUCT,
    imageUrl: product && product.firstRealImageSrc(),
    whRedesignRequestId: redesignRequest && redesignRequest.whRedesignRequestId()
  };
  dispatch(createOrSelectFeedbackItem({ createData }));
  dispatch(setFeedbackOpen(true));
};
